var render = function render(){var _vm=this,_c=_vm._self._c;return _c('em',{staticClass:"container-icon",class:[_vm.classe],style:({'font-size': _vm.size, 'color': _vm.cor})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }